// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SeasonalDiscountUnibrow-cls1___5c10ba3dcc0e12a3f1c{/*!*/}.SeasonalDiscountUnibrow-cls2__b527a50a4781a7800bd6{background:#0954d3;height:85px;padding:12px;display:flex;align-items:center;justify-content:center;grid-gap:20px;gap:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SeasonalDiscountUnibrow-cls1___5c10ba3dcc0e12a3f1c",
	"cls2": "SeasonalDiscountUnibrow-cls2__b527a50a4781a7800bd6 SeasonalDiscountUnibrow-cls1___5c10ba3dcc0e12a3f1c"
};
export default ___CSS_LOADER_EXPORT___;
